<template>
  <div class="overView">
    <div class="left_echarts">
      <div class="left_echarts_top">
        <timeCkuli @btnClick="backMessage" @changeTime="changeTime" :showChoose="true"></timeCkuli>
      </div>

      <div class="left_echarts_content">
        <div class="cross">
          <div class="line"></div>
          <div class="title">订单概览</div>
        </div>

        <div class="dataInfo">
          <div class="dataInfo_item">
            <img src="../../assets/img/dataBoard/one.png" class="img" alt/>
            <div class="info">
              <div class="info_num">{{dataInfo.all }}</div>
              <div class="info_title">全部订单数(单)</div>
            </div>
          </div>
          <div class="dataInfo_item">
            <img src="../../assets/img/dataBoard/two.png" class="img" alt/>
            <div class="info">
              <div class="info_num">{{dataInfo.pay}}</div>
              <div class="info_title">已付款订单(单)</div>
            </div>
          </div>
          <div class="dataInfo_item">
            <img src="../../assets/img/dataBoard/three.png" class="img" alt/>
            <div class="info">
              <div class="info_num">{{dataInfo.waitSend}}</div>
              <div class="info_title">待发货订单(单)</div>
            </div>
          </div>
          <div class="dataInfo_item">
            <img src="../../assets/img/dataBoard/four.png" class="img" alt/>
            <div class="info">
              <div class="info_num">{{dataInfo.done}}</div>
              <div class="info_title">完成订单(单)</div>
            </div>
          </div>
        </div>
      </div>

      <div class="left_echarts_bottom">
        <div class="pie_title">
          <div class="line"></div>
          <div class="title">部门订单占比</div>
        </div>

        <el-select class="select" v-model="value" placeholder="请选择" @change="changevalue">
          <el-option
            v-for="item in options"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <echarts :option="pieChart"></echarts>
      </div>
    </div>

    <div class="right_echarts">
      <div class="cross">
        <div class="line"></div>
        <div class="title">订单总数趋势</div>
      </div>
      <timeCkuli class="timeCkuli" :btnList="btnList" @btnClick="dingdanqushi"></timeCkuli>

      <div class="lineEchart">
        <echarts :option="lineChart"></echarts>
      </div>
    </div>
  </div>
</template>

<script>
  import timeCkuli from "../components/timeChuli";
  import dayjs from "dayjs";
  import moment from 'moment'
  import echarts from "../../components/commonComponents/echarts";

  export default {
    components: {
      timeCkuli,
      echarts
    },
    data() {
      return {
        dataInfo: {},
        value: "",
        orgId: '',
        pieStatus: [10, 11, 12, 13, 14],
        options: [
          {label: '全部订单', value: '0'},
          {label: '已付款订单', value: '1'},
          {label: '待发货订单', value: '2'},
          {label: '待收货订单', value: '3'},
          {label: '已取消订单', value: '4'},
          {label: '已完成订单', value: '5'}
        ],
        pieChart: {},
        lineChart: {},
        btnList: [
          {
            type: "DAY",
            name: "近一周",
            active: true
          },
          {
            type: "MONTH",
            name: "近一月",
            active: false
          },
          {
            type: "YEAR",
            name: "近一年",
            active: false
          }
        ],
        startDate: null,
        endDate: null,
        hourse: moment().startOf('day').format('x'),
        day: dayjs().subtract(7, 'day').startOf('day').valueOf(),
        month: dayjs().subtract(1, 'month').startOf('month').valueOf(),
        year: dayjs().subtract(1, 'year').startOf('month').valueOf(),
        now: moment().endOf('day').format('x'),
      };
    },
    created() {
      this.startDate = this.hourse
      this.endDate = this.now
      this.getPie();
      this.getLine(this.day, this.now, 'DAY');
      // 订单概览
      this.orderCount();
    },
    methods: {
      changevalue(str) {
        let param = {
          "0": [10, 11, 12, 13, 14],
          "1": [11],
          "2": [11],
          "3": [12],
          "4": [13],
          "5": [14],
        }
        this.pieStatus = param[str];
        this.getPie();
      },
      backMessage(str) {
        this.endDate = this.now
        switch (str) {
          case '1':
            this.startDate = this.hourse;
            break;
          case '2':
            this.startDate = this.day;
            break;
          case '3':
            this.startDate = this.month;
            break;
          case '4':
            this.startDate = this.year;
            break;
          case '5':
            this.startDate = null
            this.endDate = null
            break;
        }
        this.getPie();
        this.orderCount();
        this.$forceUpdate()
      },
      changeTime(e) {
        let date = 24 * 60 * 60 * 1000;
        if (e) {
          this.startDate = e[0]
          this.endDate = e[1] + date - 1000
          this.getPie();
          this.orderCount();
          this.$forceUpdate()
        }
      },
      dingdanqushi(str) {
        console.log("222", str);
        if (str === "DAY") {
          this.getLine(this.day, this.now, "DAY");
        } else if (str === "MONTH") {
          this.getLine(this.month, this.now, "DAY");
        } else if (str === "YEAR") {
          this.getLine(this.year, this.now, "MONTH");
        }
      },
      getPie() {
        // 订单占比
        this.$axios.post(this.$url.orderByOrg, {
          statusArr: this.pieStatus,
          startDate: this.startDate,
          endDate: this.endDate
        }).then(res => {
          console.log("我是订单占比", res);
          let arr = res.data.map(_ => {
            return _.orgName;
          });
          let data = res.data.map(_ => {
            _["value"] = _.count;
            _["name"] = _.orgName;
            return _;
          });
          this.pieChart = {
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
              orient: "vertical",
              left: "20",
              top: "60",
              data: arr
            },
            series: [
              {
                name: "订单数",
                type: "pie",
                radius: "55%",
                center: ["50%", "60%"],
                data: data,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)"
                  }
                }
              }
            ]
          };
        });
      },
      getLine(startDate, endDate, timeGranularity) {
        // 订单折线图
        this.$axios.post(this.$url.orderChart, {
          startDate: startDate,
          endDate: endDate,
          timeGranularity: timeGranularity
        }).then(res => {
          console.log("我是订单折线图", res);
          let data = res.data.map(_ => {
            return _.date;
          });
          let all = res.data.map(_ => {
            return _.all;
          });
          let cancel = res.data.map(_ => {
            return _.cancel;
          });
          let done = res.data.map(_ => {
            return _.done;
          });
          let pay = res.data.map(_ => {
            return _.pay;
          });
          let waitSend = res.data.map(_ => {
            return _.waitSend;
          });
          console.log(all, cancel, done, pay, waitSend);

          this.lineChart = {
            xAxis: {
              boundaryGap: false,
              left: "20",
              type: "category",
              data: data
            },
            yAxis: {
              type: "value"
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true
            },
            legend: {
              data: ["已付款", "待发货", "已取消", "已完成", "订单总数"],
              right: "80px",
              top: "20"
            },
            tooltip: {
              trigger: "axis"
            },

            series: [
              {
                name: "已付款",
                type: "line",
                stack: "总量",
                smooth: true,
                data: pay
              },
              {
                name: "待发货",
                type: "line",
                smooth: true,
                stack: "总量",
                data: waitSend
              },
              {
                name: "已取消",
                smooth: true,
                type: "line",
                stack: "总量",
                data: cancel
              },
              {
                name: "已完成",
                smooth: true,
                type: "line",
                stack: "总量",
                data: done
              },
              {
                name: "订单总数",
                smooth: true,
                type: "line",
                stack: "总量",
                data: all
              }
            ]
          };
        });
      },
      // 订单概览
      orderCount() {
        this.$axios.post(this.$url.orderCount, {
          startDate: this.startDate,
          endDate: this.endDate
        }).then(res => {
          console.log("我是订单概览", res);
          if (res.code == 0) {
            this.dataInfo = res.data;
          }
        });
      },

      orderChart() {
      },
    }
  };
</script>

<style lang='less' scoped>
  .overView {
    background-color: #fff;
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .left_echarts {
      background-color: #fff;
      padding: 0 20px;
      width: 50%;
      height: 100%;

      .left_echarts_top {
        height: 69px;
        width: 100%;
        line-height: 69px;
        position: relative;
        background-color: #fff;
      }

      .left_echarts_content {
        padding-top: 20px;

        .dataInfo {
          display: flex;
          margin-bottom: 20px;
          justify-content: space-between;
        }

        .dataInfo_item {
          display: flex;
          align-items: center;
          height: 72px;
          width: 181px;
          box-sizing: border-box;
          background-color: pink;
          padding: 20px 15px;
          border-radius: 3px;

          .img {
            height: 32px;
            width: 32px;
            margin-right: 20px;
          }

          .info {
            color: rgba(255, 255, 255, 1);

            .info_num {
              font-size: 20px;
              font-weight: bold;
              margin-bottom: 5px;
            }

            .info_title {
              font-size: 14px;
            }
          }
        }

        .dataInfo_item:nth-child(1) {
          background: rgba(3, 169, 243, 1);
        }

        .dataInfo_item:nth-child(2) {
          background: rgba(251, 120, 120, 1);
        }

        .dataInfo_item:nth-child(3) {
          background: rgba(171, 140, 228, 1);
        }

        .dataInfo_item:nth-child(4) {
          background: rgba(0, 194, 146, 1);
        }
      }

      .left_echarts_bottom {
        height: 587px;
        position: relative;
        width: 100%;

        .select {
          position: absolute;
          right: 0;
          top: 15px;
          z-index: 999;
        }
      }
    }

    .line {
      width: 3px;
      height: 19px;
      background: rgba(102, 102, 102, 1);
      margin-right: 5px;
    }

    .title {
      font-size: 18px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }

    .pie_title {
      position: absolute;
      top: 20px;
      left: 20px;
      display: flex;
      align-items: center;
    }

    .cross {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }

    .right_echarts {
      width: 50%;
      height: 100%;
      padding: 20px;
      position: relative;

      .timeCkuli {
        position: absolute;
        right: -15px;
        top: 20px;
      }

      .lineEchart {
        height: 750px;
        width: 100%;
      }
    }
  }
</style>
